/**
 * naming conventions:
 * use device agnostic verb (e.g. "select" not "click" or "touch")
 * use basic noun, what is it?
 *
 *  verb   noun
 * "select_button"
 */

/**
 * TODO Replace amplitudeEvents object current usage with the new AMPLITUDE_EVENTS object
 */
export const amplitudeEvents = {
    slider: "select_slider",
    button: "select_button",
    login_error: "login_error_code"
};

export const AMPLITUDE_EVENTS = {
    CHANGE_FIELD: "change_field",
    REPORT_DIAGNOSTICS: "report_diagnostics",
    INITIALIZE_APPLICATION: "initialize_application_complete_event",
    SELECT_BUTTON: "select_button",
    SELECT_EVENT: "select_event",
    SELECT_FIELD: "select_field",
    SELECT_LINK: "select_link",
    SELECT_MENU: "select_menu",
    SELECT_SLIDER: "select_slider",
    SELECT_VIEW: "select_view",
    TOGGLE_EVENT: "toggle_event",
    VIEW_PAGE: "view_page"
} as const;
